import React,{useState} from 'react';
import {Field, reduxForm} from "redux-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import {TextInput} from "../../../reduxFormComponents/TextInput";
import {connect} from "react-redux";
import FileUpload from "../../../reduxFormComponents/FileUpload";
import CircularProgress from "@material-ui/core/CircularProgress";
import useLoading from "../../../../hooks/useLoading";
import {InputAdornment} from '@material-ui/core';
import {checkShortHashExist} from '../../../../api'

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    fields: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        width: '100%',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),

    },
    field: {
        marginBottom: theme.spacing(4),
        flexShrink: 0
    },
    actions: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: theme.spacing(1),
    },

}));
const PersonalDetailsStep = ({ auth, change,handleSubmit,initialValues}) => {
    const classes = useStyles()
    const {t} = useTranslation();
    const [loading, setLoading] = useLoading()

    const [shortHash,setShortHash] = useState({isValid:true,error:null,initalValue:initialValues.shortHash})

    return <form onSubmit={handleSubmit} className={classes.root}>
                <div className={classes.fields}>
                    <Field name="fullName" className={classes.field} component={TextInput} type={'text'}
                           label={t('fullName')}
                           required/>
                    <Field name="email" className={classes.field} component={TextInput} type={'email'}
                           label={t('email')}
                           required/>
                    <Field name="phone" className={classes.field} component={TextInput} type={'tel'}
                           label={t('phone')}
                           required/>
                    <Field name="shortHash" className={classes.field} component={TextInput}
                           type={'text'}
                           InputProps={{
                            endAdornment: <InputAdornment position="end">.agendia.mx</InputAdornment>,
                          }}
                          onBlur={async(e)=>{
                            setShortHash({
                                isValid:false,
                                error:null,
                          })
                          if(/^[a-z0-9-]+$/.test(e.target.value)){
                            const res = await checkShortHashExist(e.target.value)
                            if(res.data.shortHashExist && initialValues.shortHash !== e.target.value){
                                setShortHash({
                                    isValid:false,
                                    error:t('short_hash_exist'),
                                })
                            
                            } else{
                                setShortHash({
                                    isValid:true,
                                    error:null,
                                })
                            }}else{
                                setShortHash({
                                    isValid:false,
                                    error:t('short_hash_invalid'),
                                })  
                            }
                            
                          }}
                           label={t('short_hash_field')} error={!!shortHash.error} helperText={shortHash.error} required />
                    <Field name="description" className={classes.field} component={TextInput} multiline minRows={4}
                           type={'text'}
                           label={t('description')}/>
                    <Field name="images" className={classes.field} component={FileUpload} label={t('pictures')}
                           setLoading={setLoading}/>
                </div>
                <div className={classes.actions}>
                    <Button type="submit" color="primary" variant="contained" className={classes.nextButton}
                            disabled={loading || !shortHash.isValid }>
                        {loading ? <CircularProgress size={'20px'} color={'white'}/> : t('next')}
                    </Button>
                </div>
        </form>
}
const ConnectedPersonalDetails = connect(state => ({
    auth: state.general.auth
}))(PersonalDetailsStep)

export default reduxForm({
    form: 'signupSupplierForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ConnectedPersonalDetails);